// removed by extract-text-webpack-plugin
module.exports = {"button":"Switch__button__1RzGN","switch":"Switch__switch__Dx4oO","buttonFalse":"Switch__buttonFalse__1i49Q","buttonTrue":"Switch__buttonTrue__24Y2J","buttonDisabled":"Switch__buttonDisabled__1cVja","switchFalse":"Switch__switchFalse__13n-q","switchTrue":"Switch__switchTrue__vJt7X"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Switch/Switch.css
// module id = 2123
// module chunks = 0